export function fitDimensionSizes(total:number,values:number[],count:number) {
  if(count<=0)return [];
  if(!Number.isFinite(total)||total<=0)return Array.from({length:count},()=>0);
  const source=Array.from({length:count},(_,index)=>Number.isFinite(values[index])?Math.max(values[index],0):0);
  const sourceTotal=source.reduce((sum,value)=>sum+value,0);
  const units=Math.round(total*10);
  const scaled=sourceTotal>0?source.map(value=>value/sourceTotal*units):source.map(()=>units/count);
  const result=scaled.map(Math.floor);
  let remaining=units-result.reduce((sum,value)=>sum+value,0);
  const order=scaled.map((value,index)=>({index,remainder:value-result[index]})).sort((a,b)=>b.remainder-a.remainder||a.index-b.index);
  for(let index=0;remaining>0;index++,remaining--)result[order[index%count].index]++;
  return result.map(value=>value/10);
}

export function rebalanceDimensionSizes(total:number,values:number[],index:number,nextValue:number) {
  if(values.length<=1)return [Math.max(total,0)];
  const current=fitDimensionSizes(total,values,values.length);
  if(index<0||index>=values.length||!Number.isFinite(nextValue))return current;
  const selected=Math.round(Math.min(Math.max(nextValue,1),Math.max(total-(values.length-1),1))*10)/10;
  const remaining=Math.max(total-selected,0);
  const others=fitDimensionSizes(remaining,current.filter((_,position)=>position!==index),values.length-1);
  let otherIndex=0;
  return current.map((_,position)=>position===index?selected:others[otherIndex++]);
}
